module.exports = __webpack_public_path__ + "static/img/icon-choose.681bc9b1.png";